import { cloneElement } from 'react'
import minMaxRange from 'root/src/shared/util/minMaxRange'

export default ({
	showItems, isMobileRes, startItem, item, onChangeItemCallbackArr, scrollPosition,
}) => (element, index) => {
	const dist = isMobileRes ? 0 : Math.floor(showItems / 2) - index
	const distAbs = Math.abs(dist)
	const hideItemsBreakpoint = (window.innerWidth < 1050 && !isMobileRes) ? 1 : 0.1
	const scale = 1 - distAbs * hideItemsBreakpoint
	const translateAbs = minMaxRange(1e6 / window.innerWidth, 760, 1000)
	const translate = !isMobileRes ? translateAbs * dist : 0

	const itemOverlay = {
		position: 'absolute',
		top: 0,
		left: 0,
		bottom: 0,
		right: 0,
		zIndex: 1,
		cursor: 'pointer',
	}

	const elementModified = startItem === item && dist === 0
		? cloneElement(element, { isStartItem: true, onChangeItemCallbackArr })
		: cloneElement(element, { onChangeItemCallbackArr })

	return (
		<li
			key={item - dist}
			style={{
				listStyle: 'none',
				transition: 'transform 0.2s',
				zIndex: -distAbs,
				transform: `scale(${scale}) translateX(${translate}px)`,
				margin: `0 ${isMobileRes ? 8 : 0}px`,
			}}
		>
			<div>
				{dist !== 0
					?	(
						<div
							onClick={() => {
								scrollPosition(-dist)
							}}
							style={itemOverlay}
						/>
					)
					: null}
				{elementModified}
			</div>
		</li>
	)
}
